/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8cc4dbd2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "upload-image-toolbar h-full relative"
};
const _hoisted_2 = {
  class: "flex flex-col justify-start items-center supported-formats text-white"
};
const _hoisted_3 = {
  class: "w-36 font-bold text-base md:text-lg text-center"
};
const _hoisted_4 = {
  class: "py-1 opacity-50 text-xs text-center"
};
const _hoisted_5 = {
  for: "fileInput",
  class: "btn btn-primary font-semibold cursor-pointer w-full"
};
const _hoisted_6 = ["accept"];
const _hoisted_7 = {
  class: "flex flex-wrap mt-4 mb-4"
};
const _hoisted_8 = {
  class: "flex gap-4 p-3"
};
const _hoisted_9 = {
  class: "image relative"
};
const _hoisted_10 = {
  class: "indicator"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src", "onClick"];
const _hoisted_13 = {
  key: 1,
  class: "w-20 h-20 bg-gray-200 flex items-center justify-center"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-gray-400 text-sm"
}, "No preview available", -1));
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "flex flex-col gap-2"
};
const _hoisted_17 = {
  class: "file-name"
};
const _hoisted_18 = ["data-tip"];
const _hoisted_19 = {
  class: "text-white"
};
const _hoisted_20 = {
  class: "badges"
};
const _hoisted_21 = {
  class: "badge badge-neutral"
};
const _hoisted_22 = {
  class: "progress-message text-white"
};
const _hoisted_23 = {
  key: 0,
  class: "progress w-full"
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 2
};
const _hoisted_26 = {
  class: "flex gap-4 p-2"
};
const _hoisted_27 = {
  class: "image relative"
};
const _hoisted_28 = {
  class: "indicator"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "inline-block w-4 h-4 stroke-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [/*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
})], -1));
const _hoisted_31 = [_hoisted_30];
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  key: 1,
  class: "w-20 h-20 bg-gray-200 flex items-center justify-center"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-gray-400 text-sm"
}, "No preview available", -1));
const _hoisted_35 = [_hoisted_34];
const _hoisted_36 = {
  class: "flex flex-col gap-2"
};
const _hoisted_37 = {
  class: "file-name"
};
const _hoisted_38 = ["data-tip"];
const _hoisted_39 = {
  class: "text-white"
};
const _hoisted_40 = {
  class: "badges"
};
const _hoisted_41 = {
  class: "badge badge-neutral"
};
const _hoisted_42 = {
  class: "progress-message text-white"
};
const _hoisted_43 = {
  key: 0
};
const _hoisted_44 = {
  class: "text-white"
};
const _hoisted_45 = {
  class: "upload-error-message-card"
};
const _hoisted_46 = {
  class: "flex flex-col"
};
const _hoisted_47 = {
  class: "flex"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "File: ", -1));
const _hoisted_49 = {
  class: "block truncate"
};
import useNodeClient from '@/composables/services/useNodeClient';
import { useDropzone } from 'vue3-dropzone';
import { useImagesStore } from '@/stores/images';
import { useConfiguratorStore } from '@/stores/configurator';
export default {
  __name: 'UploadImageWrapper',
  props: {
    label: String,
    placeholder: String,
    errorMessageClass: String
  },
  emits: ['change', 'handle-image', 'uploaded-images'],
  setup(__props, {
    emit: __emit
  }) {
    // import Adapter from '@/services/adapter'
    const Adapter = useNodeClient();
    const configuratorStore = useConfiguratorStore();
    const {
      MAX_FILES,
      MAX_FILE_SIZE_BASE,
      MAX_FILE_SIZE,
      ACCEPT_FORMATS,
      ACCEPT_FORMATS_STRING,
      ACCEPT_FORMATS_DISPLAY
    } = useImagesStore();
    const {
      checkedDrawer
    } = storeToRefs(configuratorStore);
    watch(checkedDrawer, value => {
      if (!value) {
        reset();
      }
    });
    const props = __props;
    const emit = __emit;
    const files = ref([]);
    const filePreviews = ref([]);
    const filePreviews_rejected = ref([]);
    const errorMsgs = ref([]);
    const filesUploading = ref([]);
    const uploadedFiles = ref([]);
    const isDisabled = computed(() => files.value.length >= MAX_FILES);
    const errorVisible = computed(() => errorMsgs.value.length > 0);
    const {
      getRootProps,
      getInputProps,
      isDragActive
    } = useDropzone({
      onDrop: (acceptedFiles, rejectedFiles) => {
        reset();
        // errorMsgs.value = []
        const availableSpots = MAX_FILES - files.value.length;
        if (acceptedFiles.length > availableSpots) {
          const excessFiles = acceptedFiles.splice(availableSpots);
          rejectedFiles.push(...excessFiles.map(handleExcessFile));
        }
        files.value.push(...acceptedFiles);

        // handleExcessFiles(rejectedFiles)
        updateFilePreviews();
        emit('change', files.value);
        submitImages();
      },
      onDropRejected(rejectedFiles) {
        handleRejectedFiles(rejectedFiles);
        setRejectedPreviewableFiles(rejectedFiles);
      },
      maxSize: MAX_FILE_SIZE,
      accept: ACCEPT_FORMATS_STRING
    });

    // ERROR HANDLERS START ------------------------------------------------------
    function handleExcessFile(file) {
      file.showPreview = true;
      return {
        file: makeFileForPreview(file),
        errors: [{
          code: 'too-many-files',
          message: errorMessage(file, 'too-many-files')
        }]
      };
    }
    function handleRejectedFiles(rejectedFiles) {
      rejectedFiles.forEach(({
        file,
        errors
      }) => {
        if (errors && errors.length > 0 && !file.showPreview) {
          errors.forEach(error => handleFileError(file, error));
        }
      });
    }
    function handleFileError(file, error) {
      const err = {
        fileName: file.name,
        error: error ? errorMessage(file, error.code) : errorMessage()
      };
      errorMsgs.value.push(err);
    }
    function errorMessage(file, errorCode = 'general-error') {
      return {
        // 'file-too-large': this.$t('gallery.fileTooLarge', [file.name, MAX_FILE_SIZE_BASE]),
        // 'file-invalid-type': this.$t('gallery.fileInvalidType', [ACCEPT_FORMATS_DISPLAY]),
        // 'too-many-files': this.$t('gallery.tooManyFiles', [MAX_FILES]),
        // 'upload-error': this.$t('gallery.failed'),
        // 'general-error': `Error while uploading file '${file.name}'.`
        'file-too-large': `File '${file.name}' is too large. Maximum file size is ${MAX_FILE_SIZE_BASE}MB.`,
        'file-invalid-type': `Invalid type. Allowed types: ${ACCEPT_FORMATS_DISPLAY}.`,
        'too-many-files': `Maximum number of files (${MAX_FILES}) exceeded.`,
        'upload-error': `Uploading failed'.`,
        'general-error': `Error while uploading file '${file.name}'.`
      }[errorCode];
    }

    // ERROR HANDLERS STOP ------------------------------------------------------
    const makeFileForPreview = file => {
      const url = file.type.startsWith('image/') ? URL.createObjectURL(file) : null;
      const extension = file.name.split('.').pop();
      file.url = url;
      file.extension = extension;
      return file;
    };
    const updateFilePreviews = () => {
      filePreviews.value = files.value.map(makeFileForPreview);
      // console.log("filePreviews", filePreviews.value)
    };
    function setRejectedPreviewableFiles(rejectedFiles) {
      filePreviews_rejected.value = rejectedFiles.filter(({
        file
      }) => file.showPreview);
    }
    onUnmounted(() => {
      filePreviews.value.forEach(preview => URL.revokeObjectURL(preview));
      reset();
    });
    const submitImages = async () => {
      if (files.value.length === 0) {
        return;
      }
      const allPromises = [];
      try {
        for (const [index, file] of files.value.entries()) {
          filesUploading.value.push({
            file,
            status: 'uploading',
            error: null
          });
          const formData = new FormData();
          formData.append('file', file);

          // Example POST request - adjust URL and headers as necessary
          allPromises.push(Adapter.uploadImage(formData).then(response => {
            filesUploading.value[index].status = 'uploaded';
            uploadedFiles.value.push(response.value.data);
            return response.value.data;
          }).catch(error => {
            console.log('Catch request - Upload failed:', error);
            filesUploading.value[index].status = 'error';
            filesUploading.value[index].errors = [{
              code: 'upload-error',
              message: errorMessage(file, 'upload-error')
            }];
          }));
        }
        await Promise.all(allPromises).then(uploadedFiles => {
          const successfullyUploadedFiles = uploadedFiles.filter(Boolean);
          emit('uploaded-images', successfullyUploadedFiles);
        });
      } catch (error) {
        console.error('Upload failed:', error);
      }
    };
    function onClickImageAddToConfiguration({
      name
    }) {
      if (uploadedFiles.value.length === 0) {
        return;
      }
      const uploadedFile = uploadedFiles.value.find(file => file.sourceReference === name);
      if (!uploadedFile._id) {
        return;
      }
      emit('handle-image', uploadedFile);
    }
    const removeFile = index => {
      files.value.splice(index, 1);
      filePreviews.value.splice(index, 1);
      emit('change', files.value); // Emitting change event after file removal
    };
    const reset = () => {
      files.value = [];
      filePreviews.value = [];
      filePreviews_rejected.value = [];
      errorMsgs.value = [];
      filesUploading.value = [];
      uploadedFiles.value = [];
    };
    function truncateFileName(filename, maxLength = 25) {
      const extension = filename.slice(filename.lastIndexOf("."));
      const baseName = filename.slice(0, filename.lastIndexOf("."));
      if (baseName.length <= maxLength) {
        return filename; // Return original if it's short enough
      }
      return `${baseName.substring(0, maxLength)}... ${extension}`;
    }
    return (_ctx, _cache) => {
      const _component_SvgIcon = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _mergeProps(_unref(getRootProps)(), {
        class: [{
          'drop-zone--active': _unref(isDragActive),
          'z-50': _unref(isDragActive)
        }, "form-input--file-dropzone drop-zone relative h-full"]
      }), [_createElementVNode("div", {
        style: _normalizeStyle({
          'visibility': _unref(isDragActive) ? 'visible' : 'hidden',
          'opacity': _unref(isDragActive) ? .9 : 0
        }),
        class: _normalizeClass([{
          'z-50': _unref(isDragActive),
          'opacity-90': _unref(isDragActive)
        }, "z-50 drop-zone__overlay absolute flex justify-center items-center top-0 left-0 h-full w-full bg-slate-800"])
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_SvgIcon, {
        class: "w-10 h-10",
        fill: "white",
        svgSymbolId: "cloud-upload"
      }), _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('gallery.dropImagesHere')), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(ACCEPT_FORMATS_DISPLAY)), 1)])], 6), _createElementVNode("label", _hoisted_5, [_createTextVNode(" Upload images "), _createElementVNode("input", _mergeProps(_unref(getInputProps)(), {
        id: "fileInput",
        ref: "fileInput",
        type: "file",
        style: {
          "display": "none"
        },
        accept: _unref(ACCEPT_FORMATS_STRING)
      }), null, 16, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filePreviews), (preview, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: `file-uploading-${index}`
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
          class: _normalizeClass(["indicator-item badge badge-sm", {
            'badge-ghost': _unref(filesUploading)[index].status === 'uploading',
            'badge-success': _unref(filesUploading)[index].status === 'uploaded',
            'badge-error': _unref(filesUploading)[index].status === 'error'
          }]),
          onClick: $event => removeFile(index)
        }, null, 10, _hoisted_11), preview ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: preview.url,
          class: "h-20 w-20 object-cover",
          onClick: $event => onClickImageAddToConfiguration(preview)
        }, null, 8, _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
          class: "tooltip tooltip-bottom",
          "data-tip": preview.name
        }, [_createElementVNode("span", _hoisted_19, _toDisplayString(truncateFileName(preview.name)), 1)], 8, _hoisted_18)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(preview.extension), 1)]), _createElementVNode("div", _hoisted_22, [_unref(filesUploading)[index].status === 'uploading' ? (_openBlock(), _createElementBlock("progress", _hoisted_23)) : _createCommentVNode("", true), _unref(filesUploading)[index].status === 'uploaded' ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('gallery.uploaded')), 1)) : _createCommentVNode("", true), _unref(filesUploading)[index].status === 'error' ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('gallery.failed')), 1)) : _createCommentVNode("", true)])])])]);
      }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filePreviews_rejected), (file, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: `file-rejected-${index}`
        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", {
          class: "indicator-item badge badge-error badge-sm",
          onClick: $event => removeFile(index)
        }, _hoisted_31, 8, _hoisted_29), file.file.url ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: file.file.url,
          class: "h-20 w-20 object-cover"
        }, null, 8, _hoisted_32)) : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", {
          class: "tooltip tooltip-bottom",
          "data-tip": file.file.name
        }, [_createElementVNode("span", _hoisted_39, _toDisplayString(truncateFileName(file.file.name)), 1)], 8, _hoisted_38)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(file.file.extension), 1)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("span", null, _toDisplayString(file.errors[0].message), 1)])])])]);
      }), 128))])]), _unref(errorMsgs).length ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("ul", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errorMsgs), (error, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: `file-error-${index}`
        }, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", null, _toDisplayString(error.error), 1), _createElementVNode("div", _hoisted_47, [_hoisted_48, _createElementVNode("span", _hoisted_49, _toDisplayString(error.fileName), 1)])])])]);
      }), 128))])])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 16)]);
    };
  }
};